import { zodResolver } from '@hookform/resolvers/zod'
import { createFileRoute } from '@tanstack/react-router'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { ButtonLoading } from '@/components/ui/button'
import { Form, FormField, FormItemLayout } from '@/components/ui/form'
import { InputPassword } from '@/components/ui/input'
import { AuthCard } from '@/components/view/auth-view'

export const Route = createFileRoute('/auth/reset-password')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AuthCard title="Reset Password">
      <ResetPasswordForm />
    </AuthCard>
  )
}

/* ---------------------------------- FORM ---------------------------------- */

type ResetPasswordDto = z.infer<typeof ResetPasswordDto>
const ResetPasswordDto = z.object({
  password: z.string().min(1, { message: 'Password wajib diisi' }),
  passwordConfirmation: z
    .string()
    .min(1, { message: 'Password konfirmasi wajib diisi' }),
  token: z.string(),
})

function ResetPasswordForm() {
  const form = useForm<ResetPasswordDto>({
    resolver: zodResolver(ResetPasswordDto),
    defaultValues: getDefaultValues(),
  })

  const handleOnSubmit = form.handleSubmit(console.log, console.error)

  return (
    <Form {...form}>
      <form onSubmit={handleOnSubmit}>
        <fieldset className="flex flex-col gap-4">
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItemLayout label="Password baru" className="w-full">
                <InputPassword
                  placeholder="Masukkan password baru"
                  {...field}
                />
              </FormItemLayout>
            )}
          />
          <FormField
            control={form.control}
            name="passwordConfirmation"
            render={({ field }) => (
              <FormItemLayout
                label="Konfirmasi Password baru"
                className="w-full"
              >
                <InputPassword
                  placeholder="Masukkan ulang password baru"
                  {...field}
                />
              </FormItemLayout>
            )}
          />
          <ButtonLoading variant="yes" className="mt-6 w-full">
            Reset Password
          </ButtonLoading>
        </fieldset>
      </form>
    </Form>
  )
}

function getDefaultValues(): ResetPasswordDto {
  return {
    password: '',
    passwordConfirmation: '',
    token: '',
  }
}
